var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"extraSmall",staticClass:"d-block d-lg-none"})
}
var staticRenderFns = []

export { render, staticRenderFns }